import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Playlist } from '@model/playlist';
import { TranslateService } from '@ngx-translate/core';

export interface DeletePlaylistConfirmPopupComponentData{
  playlist: Playlist
  confirm: boolean;
}

@Component({
  selector: 'tun-delete-playlist-confirm-popup',
  templateUrl: './delete-playlist-confirm-popup.component.html',
  styleUrls: ['./delete-playlist-confirm-popup.component.scss']
})
export class DeletePlaylistConfirmPopupComponent {

  public get removeText(){
    if (this.data && this.data.playlist){
      return this.translateService.instant('playlist.remove.confirm.text').replace("{0}", this.data.playlist.title);
    }
    return this.translateService.instant('playlist.remove.confirm.title');
  }

  public static widthForPopup = "min(20rem,25vw)";

  constructor(
    public dialogRef: MatDialogRef<DeletePlaylistConfirmPopupComponentData>,
    @Inject(MAT_DIALOG_DATA) public data: DeletePlaylistConfirmPopupComponentData,
    private translateService: TranslateService
  ) {

  }

  public onYesClick(){
    this.data.confirm = true;
    this.dialogRef.close(this.data);
  }

  public onNoClick(){
    this.data.confirm = false;
    this.dialogRef.close(this.data);
  }
}
